module.exports = __webpack_public_path__ + "img/metal_l@2x.abf8c9e8.png";